if (!customElements.get('sticky-media')) {
  class StickyMedia extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('scroll', this.update.bind(this));
      window.addEventListener('resize', this.update.bind(this));

      // Reposition when the gift card recipient checkbox toggles — revealing the
      // recipient fields changes the container height, so the sticky offset is stale.
      const scope = this.closest('.shopify-section') || document;
      const recipientCheckbox = scope.querySelector('recipient-form input[type="checkbox"]');
      if (recipientCheckbox) {
        recipientCheckbox.addEventListener('change', () => {
          requestAnimationFrame(this.update.bind(this));
        });
      }

      this.update();
    }

    update() {
      const container = this.parentElement;
      const containerRect = container.getBoundingClientRect();
      const elementRect = this.getBoundingClientRect();

      const containerBottom = containerRect.bottom;

      // Reset styles if container is smaller than element or if both element and container are smaller than viewport
      if (
        containerRect.height <= elementRect.height ||
        (containerRect.height < window.innerHeight && elementRect.height < window.innerHeight)
      ) {
        this.style.position = 'static';
        this.style.top = 'auto';
        this.style.transform = 'none';
        this.classList.remove('is-sticky');
        return;
      }

      // Contain element centered inside viewport and container at all times
      if (
        containerBottom <=
        elementRect.height + (window.innerHeight * 0.5 - elementRect.height / 2) + 43
      ) {
        this.style.position = 'absolute';
        this.style.top = `${container.offsetHeight - elementRect.height}px`;
        this.style.transform = 'translateY(0)';
      } else {
        this.style.position = 'fixed';
        this.style.top = 'calc(50% + 43px)'; // Adjust for header height
        this.style.transform = 'translateY(-50%)';
        this.classList.add('is-sticky');
      }
    }
  }
  customElements.define('sticky-media', StickyMedia);
}
